import React from 'react';
import { ConfigProvider, theme } from 'antd';
import skSK from 'antd/locale/sk_SK';
import dayjs from 'dayjs';
import 'dayjs/locale/sk';

dayjs.locale('sk');

/**
 * Dark Ant theme + Slovak locale for the projects module (incl. its modals and pickers).
 * Keeps the season primary colour from the app-level ConfigProvider.
 */
const PmTheme = ({ children }) => {
  const { token } = theme.useToken();
  return (
    <ConfigProvider
      locale={skSK}
      theme={{
        inherit: false,
        algorithm: [theme.darkAlgorithm, theme.compactAlgorithm],
        token: {
          colorPrimary: token.colorPrimary,
          colorLink: token.colorLink,
          borderRadius: 4,
          colorBgContainer: '#26282b',
          colorBgElevated: '#2a2c30',
          colorBgLayout: '#1e1f21',
          colorBorder: '#3a3c40',
          colorBorderSecondary: '#2e2f33',
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default PmTheme;
